import { InjectionToken } from '@angular/core';

export const API_TOKEN = new InjectionToken<string>('API token');
export const API_TOKEN_HEADER = new InjectionToken<string>('API token header name');
